import Grid from "@mui/material/Grid";
import { styled as styling } from "@mui/material/styles";
import { Swiper } from "swiper/react";

export const SwiperStyled = styling(Swiper)((props) => ({
  width: "100%",
  overflow: "hidden",

  "& .swiper-wrapper": {
    transitionTimingFunction: "linear",
  },

  "& .swiper-slide": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "auto",
  },
}));

export const LogoContainer = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "80px",
  padding: "12px",
  minWidth: "144px",

  cursor: "pointer",

  [props.theme.breakpoints.down("lg")]: {
    height: "70px",
    padding: "10px",
    minWidth: "120px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "60px",
    padding: "8px",
    minWidth: "100px",
  },
}));

export const LogoStyled = styling("img")((props) => ({
  height: "100%",
  objectFit: "contain",
  maxWidth: "120px",
  maxHeight: "60px",
  backgroundSize: "contain",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "50px",
    maxWidth: "100px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "40px",
    maxWidth: "80px",
  },
}));

export const TrustedCompanyGrid = styling(Grid)((props) => ({
  padding: "0px 100px",
  gap: "0px",
  background: "#F7F7FF",

  [props.theme.breakpoints.down("lg")]: {
    padding: "0px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "0px 16px",
  },
}));

export const CarouselContainer = styling(Grid)((props) => ({
  // maxWidth: "1220px",
  // padding: "0px 200px",
  height: "100%",
  maxWidth: "1240px",

  [props.theme.breakpoints.down("lg")]: {
    // maxWidth: "720px",
    padding: "0px 0px",
  },

  // [props.theme.breakpoints.down("tablet")]: {
  //   maxWidth: "100%",
  // },
}));

export const CompanyButtons = styling("a")((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  borderRadius: "16px",
  border: "none",
  background: "#F7F7FF",
  alignContent: "center",

  "&:hover": {
    border: "none",
  },

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));
